import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';
import { makePermissionMeta } from '@/shared/helpers/permissions.helpers';

export const AdminCrmRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'settings',
        component: wrapRuntimeImport(() => import('./screens/settings.vue')),
        meta: { admin: true }
    },
    {
        path: 'file-categories',
        component: wrapRuntimeImport(() => import('./screens/file-categories.vue')),
        // Gated on the route too, not just in the nav: hiding the entry doesn't stop someone
        // arriving at the URL directly. `admin` and `app` compose, so this needs both.
        meta: { admin: true, ...makePermissionMeta('crm', 'filesRead') }
    },
    {
        path: 'tags',
        component: wrapRuntimeImport(() => import('./screens/tags.vue')),
        meta: { admin: true }
    },
    {
        path: 'contact-types',
        component: wrapRuntimeImport(() => import('./screens/contact-types.vue')),
        meta: { admin: true }
    },
    {
        path: 'relationship-types',
        component: wrapRuntimeImport(() => import('./screens/relationship-types.vue')),
        meta: { admin: true }
    }
];
